<template>
  <div>
    <h1>
      <font-awesome-icon icon="info-circle"/>
      {{ $t('about.title') }}
    </h1>
    <div class="text-center mt-4" v-if="!logged">
      <router-link
        class="btn btn-primary"
        :to="{name: 'UserCreate'}"
      >{{ $t('global.menu.register') }}</router-link>
    </div>
    <div class="lead mt-4" v-html="$t('about.data')"></div>
    <div class="text-center mt-4" v-if="!logged">
      <router-link
        class="btn btn-primary"
        :to="{name: 'UserCreate'}"
      >{{ $t('global.menu.register') }}</router-link>
    </div>
    <div class="text-right">v 1.11</div>
    <footer class="text-right mt-5">
      <router-link :to="{name:'AppContactForm'}" class="btn">{{$t('global.menu.contactForm')}}</router-link>
    </footer>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters({
    logged: "user/auth/logged"
  })
};
</script>



// WEBPACK FOOTER //
// src/components/app/About.vue